import { useEffect, useState } from "react";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";

interface Props {
    exportMap: Function;
    procedure: any;
    pushProps?: Function;
    pushInfo?: Function;
}

interface Resp {
    Obs: string;
    Approve: string;
}

export const BPM002 = ({ exportMap, pushInfo, pushProps }: Props) => {

    const [invalidObservation, setInvalidObservation] = useState(false);
    const [response, setResponse] = useState<Resp>({
        Approve: "",
        Obs: ""
    })

    const onExportMap = () => {
        const trimmedObservation = response.Obs.trim();

        if (pushProps) {
            pushProps({
                Approve: response.Approve,
            })
        }
        if (pushInfo) {
            pushInfo(trimmedObservation)
        }
        exportMap({ ...response, Obs: trimmedObservation })
    }

    useEffect(() => {
        if (response.Approve !== "") {
            onExportMap();
        }
    }, [response]);

    const updateForm = (app: boolean) => {
        const trimmedObservation = response.Obs.trim();

        if (trimmedObservation.length < 15) {
            setInvalidObservation(true);
            toast.error("La observación es obligatoria y debe tener mínimo 15 caracteres");
            return;
        }

        setInvalidObservation(false);
        setResponse(prev => ({ ...prev, Obs: trimmedObservation, Approve: `${app}` }));
    }

    

    return (
        <>
            <div className="row d-flex justify-content-between">
                <div className="col-md-12 mb-2">
                    <label>Observaciones <span className="text-danger">*</span></label>
                    <textarea
                        className={`form-control ${invalidObservation ? "is-invalid" : ""}`}
                        placeholder="Escriba una observación de mínimo 15 caracteres"
                        value={response.Obs}
                        onChange={(e) => {
                            setResponse({ ...response, Obs: e.target.value });
                            if (invalidObservation && e.target.value.trim().length >= 15) {
                                setInvalidObservation(false);
                            }
                        }}
                    />
                </div>
                <div className="col-md-4 position-relative">
                    <BasicButton icon="ri-checkbox-circle-line" eventClick={() => { updateForm(true) }} >Aprobar</BasicButton>
                </div>

                <div className="col-md-4 d-flex justify-content-end position-relative">
                    <BasicButton icon="ri-close-circle-line" eventClick={() => { updateForm(false) }} >Rechazar</BasicButton>
                </div>
            </div>

        </>
    );
};
